const ENV = process.env.REACT_APP_ENV;

const API_BASE_URL =
    ENV === "dev"
        ? process.env.REACT_APP_API_BASE_URL
        : window.location.origin;

const HEADER_TOKEN = "radius";

function getLoginDetails() {
    return {
        email: localStorage.getItem("loggedInEmail") || "",
        password: localStorage.getItem("loggedInPassword") || ""
    };
}

export const apiFetch = async (endpoint, options = {}) => {
    try {
        const { email, password } = getLoginDetails();

        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            ...options,
            headers: {
                "Content-Type": "application/json",
                "X-HEADER-TOKEN": HEADER_TOKEN,
                "X-LOGIN-ID": email,
                "X-PASSWORD": password,
                ...(options.headers || {})
            }
        });

        return response;
    } catch (error) {
        console.error("API Fetch Error:", error);
        throw error;
    }
};


export const apiFetchForMultipart = async (endpoint, options = {}) => {
    try {
        const { email, password } = getLoginDetails();

        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            ...options,
            headers: {
                "HEADER_TOKEN": HEADER_TOKEN,
                "login_id": email,
                "password": password,
                ...(options.headers || {})
            }
        });

        return response;
    } catch (error) {
        console.error("API Fetch Error:", error);
        throw error;
    }
};
